export default __webpack_public_path__ + "static/media/Alianzas.521d324e.png";